import { DATE_FORMAT } from '../consts/index'
import moment from 'moment'

export default class DateFormatter {
  format(date, format = DATE_FORMAT) {
    return moment(date).format(format)
  }
}
